/* eslint-disable complexity */
/* eslint-disable max-len */
/* eslint-disable max-nested-callbacks */
/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';
import RateInventoryCalender from './RateInventoryCalender';
import {  currentDateHandle, openPopupSectionUIHandler, swapCategoryData, inventoryCellUIHandler, selectAllInventoryOfDate, expandCollapseCategorySection, filterStopSaleData, selectCellEventHandler, horizontalInventoryUIHandler, horizontalRowSelection, prepareDataForRateUpdate, findDateDiff, calenderDateUIHandler, sortByDate, closePopupUIHandler, pushInventoryData } from './InventoryLogics';

// InventoryLogics
import {RateInventoryFilter, renderOtaList} from './RateInventoryFilter';
import RateInventory from './RateInventory';
import Button from './Button';
// import RateupdatePopup from './RateupdatePopup';
// import BlockRelease from './BlockRelease';
import { formatDate } from './Common';
import axios from 'axios';
import Loader from './Loader';
import constants from '../../constants';
import { cookieStorageUtility } from '../../utils/utilityFunctions';

const {
  dateFormate,
  calendatSize,
  serverUrl,
  weekDaysList,
  ENCRYPTOR_KEY
} = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const MainInventory = (props) => {
  const dateYMD = currentDateHandle(new Date());
  const endDateObj = new Date();
  endDateObj.setDate(endDateObj.getDate() + 365);

  // State
  const [filterData, setFilterData] = useState({
    date_from: formatDate(dateYMD, 'yyyy-mm-dd', dateFormate),
    end_date: formatDate(dateYMD, 'yyyy-mm-dd', dateFormate),
    userId: 0,
    rateplanId: 0
  });
  const [dateList, setDateList] = useState([]);
  const [others, setOthers] = useState({
    inventorySelectedSection: {},
    horizontalInventoryRowChecked: {},
    calendarSelectedDate: {},
    categorySectionExpand: {},
    rateplanSectionExpand: {},
    ratepresentInOccupancyByCategory: {},
    rateinventorySelectedSection: {},
    horizontalRowChecked: {},
    popupUiDesign: {},
    ratepopupUiDesign: {},
    showHideButton: {
      updateRate: 0,
      block: 0,
      unBlock: 0,
      stopSale: 0,
      startSale: 0,
      allocation: 0
    },
    popupIdentifier: '',
    selectedCategory: 0,
    isPreviousDayShow: 0,
    endDate: endDateObj,
    updateRate: {},
    extrabed: {
      extra_bed: 'Extrabed',
      child: 'Child'
    }
  });
  const [loader, setLoader] = useState({
    flag: 1,
    noData: 0,
    alert: 0,
    screenDisable: 0,
    createCategory: 0,
    createRateplan: 0,
    type: '',
    message: ''
  });
  const [commonData, setCommonData] = useState({
    occupancyList: {},
    otaList: {},
    otaData: {},
    usableCategory: {},
    usableRateplans: {},
    rateUpdateData: {},
    InventoryEventHandlingData: [],
    startStopSaleEventHandlingData: [],
    eventHandlingData: [],
    selectedDays: Object.keys(weekDaysList)
  });
  const [backup, setBackup] = useState({
    rateassociatedwithuser: {},
    rateInventory: {},
    categoryList: {},
    categorymaster: {},
    ota_category_rateplan: {}
  });
  const [eventData, setEventData] = useState({
    description: '',
    rate: '',
    extrabed_rate: '',
    kid_rate: '',
    child_with_bed: '',
    infent_rate: '',
    numberOfRooms: ''
  });

  useEffect(() => {
    getrateAssociatedWithUser();
  }, []);

  /****** API CAll Section  */

  const getrateAssociatedWithUser = () => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    axios(serverUrl + 'rateinventory/rateassociatedwithuser', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { hotelId }
    }).then(response => {
      // eslint-disable-next-line no-param-reassign
      response = response.data;
      if (response.status_code === 200) {
        var prevLoadingState = { ...loader };
        prevLoadingState['flag'] = 0;
        setLoader(prevLoadingState);
        if (Object.keys(response.data.categorymaster).length === 0) {
          let prevLoader = { ...loader };
          prevLoader['screenDisable'] = 1;
          prevLoader['createCategory'] = 1;
          setLoader(prevLoader);
          return;
        }
        let prevBackupStatus = JSON.parse(JSON.stringify(backup));
        prevBackupStatus['rateassociatedwithuser'] = response.data.otadata;
        prevBackupStatus['ota_category_rateplan'] = response.data.ota_category_rateplan;
        prevBackupStatus['categorymaster'] = response.data.categorymaster;
        let otaIds = Object.keys(prevBackupStatus['rateassociatedwithuser']);
        for (var i = 0; i < otaIds.length; i++) {
          let categoryIds = Object.keys(prevBackupStatus['rateassociatedwithuser'][otaIds[i]]['category']);
          for (var c = 0; c < categoryIds.length; c++) {
            prevBackupStatus['categoryList'][categoryIds[c]] =
              prevBackupStatus['rateassociatedwithuser'][otaIds[i]]['category'][categoryIds[c]];
          }
        }
        setBackup(prevBackupStatus);
        let prevStatus = { ...commonData };
        prevStatus['occupancyList'] = response.data.occupancylist;
        setCommonData(prevStatus);
        makeUsableCategory();
      }
    }).catch(error => {
      console.log(error);
      var prevLoadingState = { ...loader };
      prevLoadingState['flag'] = 0;
      setLoader(prevLoadingState);
    });
  }

  const getRateInventory = (userId, categoryId, ratePlanId) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    let dateYMD = currentDateHandle(filterData.date_from);
    const requestData = {};
    requestData['data'] = {};
    requestData['data']['userId'] = userId;
    requestData['data']['categoryId'] = categoryId;
    requestData['data']['rateplanId'] = ratePlanId;
    requestData['data']['startDate'] = dateYMD;
    requestData['data']['dateRange'] = calendatSize;
    requestData['data']['hotelId'] = hotelId;
    axios(serverUrl + 'rateinventory/inventory', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: requestData
    }).then(response => {
      // eslint-disable-next-line no-param-reassign
      response = response.data;
      if (response.status_code === 200) {
        /*** If there is not any category or rateplan  */
        //this.state.loader.noData==1
        if (Object.keys(response.data.categoryrateplanmapping).length === 0) {
          let prevLoader = { ...loader };
          prevLoader['screenDisable'] = 1;
          prevLoader['createCategory'] = 1;
          setLoader(prevLoader);
          return;
        }
        if (Object.keys(response.data.categoryrateplanmapping).length > 0) {
          let catId = Object.keys(response.data.categoryrateplanmapping)[0];
          if (Object.keys(response.data.categoryrateplanmapping[catId]).length === 0) {
            let prevLoader = { ...loader };
            prevLoader['screenDisable'] = 1;
            prevLoader['createRateplan'] = 1;
            setLoader(prevLoader);
            return;
          }
        }
        let prevState = JSON.parse(JSON.stringify(backup));
        prevState['rateInventory'] = JSON.parse(JSON.stringify(response.data.rateinventorylist));
        prevState['categoryrateplanmapping'] = response.data.categoryrateplanmapping;
        setBackup(prevState);
        let prevloaderState = JSON.parse(JSON.stringify(loader));
        prevloaderState['noData'] = 0;
        setLoader(prevloaderState);
        handlePushInventoryData(userId, response.data);
      } else if (response.status_code === 400) {
        let prevCommonState = JSON.parse(JSON.stringify(commonData));
        prevCommonState.otaData = {};
        setCommonData(prevCommonState);
        let prevloaderState = JSON.parse(JSON.stringify(loader));
        prevloaderState['flag'] = 0;
        prevloaderState['noData'] = 1;
        setLoader(prevloaderState);
      }
    });
  }

  const handelChangeValue = (e, type) => {
    const eventData = { ...eventData };
    eventData[type] = e.target.value;
    setEventData(eventData);
  }

  const sartSaleStopSaleApiCall = (requestData, identifier, successMsg, callBack) => {
    // let response = {};
    const hotelId = cookieStorageUtility.fetch('hotelId');
    let flag = false;
    let apiRequestData = {};
    apiRequestData['description'] = eventData.description;
    apiRequestData['userId'] = filterData.userId;
    apiRequestData['type'] = identifier;
    apiRequestData['data'] = requestData;
    //this.state.commonData.InventoryEventHandlingData,identifier,successMsg,(result)=>{
    axios(serverUrl + 'rateinventory/stopsale', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        ...apiRequestData
      }
    }).then(response => {
      // eslint-disable-next-line no-param-reassign
      response = response.data;
      if (response.status_code === 200) {
        flag = true;
        resetAllDataRelatedToPopup();
        getRateInventory(filterData.userId, 0, 0);
        if (identifier === 'startsale') {
          customAlert(1, 'success', 'Start sale has been successfully');
        } else {
          customAlert(1, 'success', 'Stop sale has been successfully');
        }
      } else {
        customAlert(1, 'error', 'There is some technical issue');
        //alert("There is some technical issue");
      }
      closePopupUIHandler('', identifier);
    });
    callBack(flag);
  }

  const updateRateApiEvent = (updateRate, data, dayCode) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    var prevLoadingState = { ...loader };
    prevLoadingState['flag'] = 1;
    setLoader(prevLoadingState);
    // let response = {};
    let apiRequestData = {};
    apiRequestData = updateRate;
    apiRequestData['data'] = data;
    apiRequestData['daywiserate'] = dayCode;
    //apiRequestData['ratepopupUiDesign'] = this.state.others['ratepopupUiDesign'];

    axios(serverUrl + 'rateinventory/updaterate', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        ...apiRequestData
      }
    }).then(response => {
      // eslint-disable-next-line no-param-reassign
      response = response.data;
      prevLoadingState = { ...loader };
      prevLoadingState['flag'] = 0;
      setLoader(prevLoadingState);
      if (response.status_code === 200) {
        customAlert(1, 'success', 'Rate has been successfully updated');
        closePopupUIHandler('', 'updaterate');
        resetRateUpdatePopup();
        getRateInventory(filterData.userId, 0, 0);
      } else {
        customAlert(1, 'error', 'There is some technical error');
      }
    }).catch(error => {
      customAlert(1, 'error', 'There is some technical error');
    });
  }

  const blockUnblockEventHandler = (element, identifier) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    var prevLoadingState = { ...loader };
    prevLoadingState['flag'] = 1;
    setLoader(prevLoadingState);
    let apiRequestData = {};
    // eslint-disable-next-line no-undef
    if (eventData.numberOfRooms.trim() === '') {
      customAlert(1, 'error', 'No of inventory is required');
      return;
    }

    // let setDateRange = this.state.logicObj.sortByDate(this.state.commonData.InventoryEventHandlingData);
    apiRequestData['data'] = commonData.InventoryEventHandlingData;
    apiRequestData['type'] = identifier;
    apiRequestData['number_of_rooms'] = eventData.numberOfRooms;
    apiRequestData['description'] = eventData.description;
    apiRequestData['userId'] = filterData.userId;
    axios(serverUrl + 'rateinventory/stopsale', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        ...apiRequestData
      }
    }).then(response => {
      // eslint-disable-next-line no-param-reassign
      response = response.data;
      prevLoadingState = { ...loader };
      prevLoadingState['flag'] = 0;
      setLoader(prevLoadingState);
      if (response.status_code === 200) {
        customAlert(1, 'success', 'Inventory has been successfully updated');
        resetAllDataRelatedToPopup();
        getRateInventory(filterData.userId, 0, 0);
        closePopupUIHandler('', identifier);
      } else {
        customAlert(1, 'error', response.message);
      }
    });
  }

  const resetRateUpdatePopup = () => {
    let prevState = others;
    prevState['updateRate'] = {};
    setOthers(prevState);
  }

  const handlePushInventoryData = (userId, inventoryData) => {
    let prevState = { ...commonData };
    let categoryMaster = JSON.parse(JSON.stringify(backup['categorymaster']));
    let otaData = JSON.parse(JSON.stringify(commonData.otaData));
    let backupData = JSON.parse(JSON.stringify(backup));
    pushInventoryData(
      others,
      otaData,
      inventoryData,
      categoryMaster,
      filterData.userId,
      backupData,
      response => {
        prevState['otaData'] = response['otaData'];
        setCommonData(prevState);
        setOthers(response['others']);
        let prevLoaderState = JSON.parse(JSON.stringify(loader));
        prevLoaderState['flag'] = 0;
        setLoader(prevLoaderState);
      }
    );
  }

  const makeUsableCategory = () => {
    let backupData = JSON.parse(JSON.stringify(backup));
    let otaData = JSON.parse(JSON.stringify(commonData.otaData));
    swapCategoryData(others, otaData, backupData, filterData.userId, response => {
      let prevState = commonData;
      prevState['otaData'] = response['otaData'];
      setCommonData(prevState);
      setOthers(response['others']);
      var prevLoadingState = { ...loader };
      // prevLoadingState['noData']=1;
      prevLoadingState['flag'] = 0;
      setLoader(prevLoadingState);
      getRateInventory(filterData.userId, 0, 0);
    });
  }

  /********* End  ******** */

  const resetAllDataRelatedToPopup = () => {
    let prevOther = JSON.parse(JSON.stringify(others));
    prevOther['inventorySelectedSection'] = {};
    prevOther['popupUiDesign'] = {};
    prevOther['categorySectionExpand'] = {};
    prevOther['rateplanSectionExpand'] = {};
    prevOther['rateinventorySelectedSection'] = {};
    prevOther['ratepopupUiDesign'] = {};
    prevOther['calendarSelectedDate'] = {};
    prevOther['horizontalInventoryRowChecked'] = {};
    prevOther['showHideButton'] = { allocation: 0, block: 0, startSale: 0, stopSale: 0, unBlock: 0, updateRate: 0 };
    setOthers(prevOther);
    let prevCommon = JSON.parse(JSON.stringify(commonData));
    prevCommon['InventoryEventHandlingData'] = [];
    prevCommon['startStopSaleEventHandlingData'] = [];
    prevCommon['eventHandlingData'] = [];
    setCommonData(prevCommon);
  }

  const dateChangeHandler = (element, value) => {
    const prevfilterData = filterData;
    prevfilterData[value.key] = element;
    setFilterData(prevfilterData);
    let dateYMD = currentDateHandle(prevfilterData.date_from);
    let dateMMDDYY = formatDate(dateYMD, 'yyyy-mm-dd', dateFormate);
    let dateList = calenderDateUIHandler(dateMMDDYY, calendatSize);
    setDateList(dateList);
    let prevOther = JSON.parse(JSON.stringify(others));
    prevOther['categorySectionExpand'] = {};
    prevOther['rateplanSectionExpand'] = {};
    setOthers(prevOther);
    getRateInventory(filterData.userId, 0, 0);
  }

  const inventoryCellUIHandler = (element, params) => {
    let othersData = JSON.parse(JSON.stringify(others));
    let commonDataCopy = JSON.parse(JSON.stringify(commonData));
    /** The below condition work when category is linked
		if(commonData.otaData[this.state.filterData.userId]['category'][params.categoryId]['linked_with']>0){
			params.categoryId=commonData.otaData[this.state.filterData.userId]['category'][params.categoryId]['linked_with'];
		}*/
    let backupData = JSON.parse(JSON.stringify(backup));
    inventoryCellUIHandler(
      othersData,
      filterData.userId,
      params.categoryId,
      params.date,
      params.identifier,
      params.ischecked,
      commonDataCopy,
      dateList,
      backupData,
      params.categoryWithMapping,
      params.localAvailCount,
      result => {
        let prevStatus = { ...others };
        prevStatus['inventorySelectedSection'] = result['inventorySelectedSection'];
        prevStatus['horizontalInventoryRowChecked'] = result['horizontalInventoryRowChecked'];
        prevStatus['showHideButton'] = result['showHideButton'];
        setOthers(prevStatus);
        let prevCommonStatus = { ...commonData };
        prevCommonStatus['InventoryEventHandlingData'] = result['InventoryEventHandlingData'];
        prevCommonStatus['startStopSaleEventHandlingData'] = result['startStopSaleEventHandlingData'];
        setCommonData(prevCommonStatus);
      }
    );
  }

  useEffect(() => {
    var dateList = calenderDateUIHandler(filterData.date_from, calendatSize);
    setDateList(dateList);
    //this.getRateInventory(this.state.filterData.userId,0,0);
  }, []);

  // const selectAllInventoryOfDate = (element, params) => {
  //   let backupData = JSON.parse(JSON.stringify(backup));
  //   selectAllInventoryOfDate(
  //     others,
  //     commonData,
  //     others.inventorySelectedSection,
  //     filterData.userId,
  //     params.date,
  //     backupData,
  //     result => {
  //       let prevState = { ...others };
  //       let prevStateCommont = { ...commonData };
  //       prevState['calendarSelectedDate'] = result['calendarSelectedDate'];
  //       prevState['inventorySelectedSection'] = result['inventorySelectedSection'];
  //       prevStateCommont['InventoryEventHandlingData'] = result['InventoryEventHandlingData'];
  //       setOthers(prevState);
  //       setCommonData(prevStateCommont);
  //       //this.setState({commonData:prevStateCommont});
  //     }
  //   );
  // }

  const expandCollapseCategorySection = (element, params) => {
    // let result = {};
    let rateassociatedwithuser = JSON.parse(JSON.stringify(backup));
    expandCollapseCategorySection(
      others.categorySectionExpand,
      others.rateplanSectionExpand,
      others.ratepresentInOccupancyByCategory,
      rateassociatedwithuser,
      commonData.otaData,
      filterData.userId,
      params.categoryId,
      params.rateplanId,
      result => {
        let prevState = { ...others };
        prevState['categorySectionExpand'] = result['categorySectionExpand'];
        prevState['rateplanSectionExpand'] = result['rateplanSectionExpand'];
        prevState['ratepresentInOccupancyByCategory'] = result['ratepresentInOccupancyByCategory'];
        prevState['selectedCategory'] = params.categoryId;
        setOthers(prevState);
        let prevCommonData = { ...commonData };
        prevCommonData['otaData'] = result['otaData'];
        setCommonData(prevCommonData, () => {
          if (params.rateplanId > 0) {
            //this.getRateInventory(this.state.filterData.userId,params.categoryId,params.rateplanId );
          }
        });
      }
    );
    // }else{
    //  result = this.state.logicObj.expandCollapseCategorySection(this.state.others.categorySectionExpand,this.state.others.rateplanSectionExpand,this.state.others.ratepresentInOccupancyByCategory,rateassociatedwithuser,this.state.commonData.otaData,this.state.filterData.userId,params.categoryId,params.rateplanId);
    // }
  }

  const filterEventHandler = (element, params) => {
    if (params.identifier === 'otachange') {
      let prevState = { ...filterData };
      prevState['userId'] = params.otaId;
      setFilterData(prevState);
      updateCommonData(params.otaId);
    } else if (params.identifier === '10dayprev') {
      resetAllDataRelatedToPopup();
      calenderPreviousFilter(params);
    } else if (params.identifier === '10daynext') {
      resetAllDataRelatedToPopup();
      calenderNextFilter(params);
    } else if (
      params.identifier === 'startsale' ||
      params.identifier === 'stopsale' ||
      params.identifier === 'allocation'
    ) {
      // var startDate = new Date(this.state.logicObj.formatDate(date, $scope.config.dateFormate,'yyyy-mm-dd'));
      // var endDate = new Date(this.state.logicObj.formatDate(endDate, $scope.config.dateFormate,'yyyy-mm-dd'));
      let backupData = JSON.parse(JSON.stringify(backup));
      filterStopSaleData(
        commonData,
        others,
        backupData,
        params.categoryId,
        params.index,
        params.identifier,
        params.userId,
        params.category_with_mapping,
        result => {
          let commonDataPrevState = JSON.parse(JSON.stringify(commonData));
          let othersDataPrevState = JSON.parse(JSON.stringify(others));
          setCommonData({
            commonData: commonDataPrevState,
            others: othersDataPrevState
          });
        }
      );
    } /*else if(identifier=='startsale' || identifier === 'stopsale' || identifier=='allocation'){
			$scope.others.popupStopsaleButton=1;
			var startDate = new Date(cf.formatDate(date, $scope.config.dateFormate,'yyyy-mm-dd'));
			var endDate = new Date(cf.formatDate(endDate, $scope.config.dateFormate,'yyyy-mm-dd'));
			if(!(endDate >= startDate)){
				$scope.others.popupStopsaleButton=0;
				 cf.notifyError($filter("translate")("INVALID_DATE"));
				 return false;
			}
			$scope.filterStopSaleData(categoryId,date,index,identifier);
		}*/ else if (
      params.identifier === 'block'
    ) {
      // var startDate = new Date(this.state.logicObj.formatDate(params.date, dateFormate, 'yyyy-mm-dd'));
      // var endDate = new Date(this.state.logicObj.formatDate(params.endDate, dateFormate, 'yyyy-mm-dd'));
      let backupData = JSON.parse(JSON.stringify(backup));
      filterStopSaleData(
        commonData,
        others,
        backupData,
        params.categoryId,
        params.index,
        params.identifier,
        params.userId,
        params.category_with_mapping,
        result => {
          let commonDataPrevState = JSON.parse(JSON.stringify(commonData));
          let othersDataPrevState = JSON.parse(JSON.stringify(others));
          setCommonData({
            commonData: commonDataPrevState,
            others: othersDataPrevState
          });
        }
      );
    }
  }

  const calenderNextFilter = (params) => {
    let dateList = Object.keys(dateList);
    var startDate = dateList[dateList.length - 1];
    let prevState = JSON.parse(JSON.stringify(filterData));
    prevState['date_from'] = formatDate(startDate, 'yyyy-mm-dd', dateFormate);
    setFilterData(prevState, () => {
      let prevDateState = JSON.parse(JSON.stringify(dateList));
      prevDateState = calenderDateUIHandler(filterData.date_from, calendatSize);
      setDateList(prevDateState);
      getRateInventory(params.otaId, 0, 0);
      /* let others = this.state.logicObj.setPrevious10DayFlag(
        this.state.others,
        this.state.filterData.date_from,
        calendatSize
      ); */
      let otherState = JSON.parse(JSON.stringify(others));
      setOthers(otherState);
    });
  }

  const calenderPreviousFilter = (params) => {
    var endDate = Object.keys(dateList)[0];
    var endDateObj = new Date(endDate);
    endDateObj.setDate(endDateObj.getDate() - 9);
    var startDate = currentDateHandle(endDateObj);
    let prevState = JSON.parse(JSON.stringify(filterData));
    prevState['date_from'] = formatDate(startDate, 'yyyy-mm-dd', dateFormate);
    setFilterData(prevState, () => {
      let prevDateState = JSON.parse(JSON.stringify(dateList));
      prevDateState = calenderDateUIHandler(filterData.date_from, calendatSize);
      setDateList(prevDateState);
      getRateInventory(params.otaId, 0, 0);
      // let others = this.state.logicObj.setPrevious10DayFlag(
      //   this.state.others,
      //   this.state.filterData.date_from,
      //   calendatSize
      // );
      let otherState = JSON.parse(JSON.stringify(others));
      setOthers(otherState);
    });
  }

  const updateCommonData = (otaId) => {
    getRateInventory(otaId, 0, 0);
  }

  const openPopupSectionUIHandler = (element, identifier) => {
    let commonDataCopy = JSON.parse(JSON.stringify(commonData));
    let othersData = JSON.parse(JSON.stringify(others));
    openPopupSectionUIHandler(identifier, commonDataCopy, othersData, result => {
      let prevState = { ...others };
      prevState['popupUiDesign'] = result['popupUiDesign'];
      prevState['popupIdentifier'] = result['popupIdentifier'];
      prevState['ratepopupUiDesign'] = result['ratepopupUiDesign'];

      setOthers(prevState);
    });
  }

  const commonEventHandler = (element, identifier) => {
    // var requestData = {};
    if (identifier.trim() === 'stopsale') {
      let successMsg = 'Stop sale has been update successfully';
      sartSaleStopSaleApiCall(
        sortByDate(commonData.InventoryEventHandlingData),
        identifier,
        successMsg,
        flag => {
          if (flag) {
            let prevState = JSON.parse(JSON.stringify(commonData));
            prevState['InventoryEventHandlingData'] = [];
            setCommonData(prevState);
          }
        }
      );
    } else if (identifier.trim() === 'startsale') {
      let successMsg = 'Start sale has been updated successfully';
      sartSaleStopSaleApiCall(
        sortByDate(commonData.startStopSaleEventHandlingData),
        identifier,
        successMsg,
        flag => {
          if (flag) {
            let prevState = JSON.parse(JSON.stringify(commonData));
            prevState['startStopSaleEventHandlingData'] = [];
            setCommonData(prevState);
          }
        }
      );
    } else if (identifier.trim() === 'allocation') {
      /*var successMsg = $filter("translate")('ALLOCATION_SUCCESS');
			var dataNeedToPush =  $scope.InventoryEventHandlingData;
			angular.forEach($scope.startStopSaleEventHandlingData, function (popupData, index) {
				dataNeedToPush.push(popupData);
			});

			requestData = angular.copy($filter('orderBy')(dataNeedToPush, 'date'));*/
      /*if($scope.maxInventoryAllocateHandler(requestData)){
				$scope.allocationApiCall(requestData,identifier,successMsg);
			}*/
    } else {
      /*cf.notifyError($filter("translate")('INVALID_EVENT_IDENTIFIER'));
			return false;*/
    }
  }

  const closePopupUIHandler = (element, identifier) => {
    closePopupUIHandler(identifier, commonData, others, result => {
      let prevState = { ...others };
      prevState['popupIdentifier'] = result['popupIdentifier'];
      prevState['popupUiDesign'] = result['popupUiDesign'];
      prevState['horizontalRowChecked'] = {};
      setOthers(prevState, () => {
        resetAllDataRelatedToPopup();
        let preveventState = { ...eventData };
        preveventState = {
          description: '',
          rate: '',
          extrabed_rate: '',
          kid_rate: '',
          child_with_bed: '',
          infent_rate: '',
          numberOfRooms: ''
        };
        setEventData(preveventState);
      });
    });
    /*if (identifier === 'stopsale') {
			$scope.inventoryDataPrepateForPopup('stopsale');
		} else if (identifier === 'updaterate') {
			$scope.others.selectedDays = Object.keys($scope.others.weekDaysList);
			$scope.resetRateUpdatePopup();
		} else if (identifier === 'unblock_block') {
			$scope.resetRateUpdatePopup();
		}*/
  }

  const selectCellEventHandler = (element, params) => {
    let othersData = JSON.parse(JSON.stringify(others));
    let commonDataCopy = JSON.parse(JSON.stringify(commonData));
    if (params.userId > 0) {
      customAlert(1, 'error', 'You can not update OTA rate or inventories');
      return false;
    }
    if (
      commonData.otaData[params.userId]['category'][params.categoryId]['rateplans'][params.ratePlanId][
        'type'
      ] === 'package'
    ) {
      customAlert(1, 'error', 'Opps , You can not update package rate');
      return false;
    }
    if (isAnyCategorySelectedCaseHandler(params.categoryId)) {
      customAlert(1, 'error', 'Multiple category rate update not allowed');
      return false;
    }
    selectCellEventHandler(params, othersData, commonDataCopy, dateList, result => {
      let prevState = { ...others };
      prevState['rateinventorySelectedSection'] = result['rateinventorySelectedSection'];
      prevState['showHideButton'] = result['showHideButton'];
      prevState['horizontalRowChecked'] = result['horizontalRowChecked'];
      setOthers(prevState, () => {
        let prevCommonState = { ...commonData };
        prevCommonState['eventHandlingData'] = result['eventHandlingData'];
        setCommonData(prevCommonState);
      });
    });
  }

  // const isAnyCategorySelectedCaseHandler = (categoryId) => {
  //   if (others.selectedCategory > 0 && others.selectedCategory !== categoryId) {
  //     return true;
  //   } else if (others.selectedCategory === 0) {
  //     let prevState = JSON.parse(JSON.stringify(others));
  //     prevState['selectedCategory'] = categoryId;
  //     setOthers(prevState);
  //     return false;
  //   } else if (others.selectedCategory === categoryId) {
  //     let prevState = JSON.parse(JSON.stringify(others));
  //     prevState['selectedCategory'] = 0;
  //     setOthers(prevState);
  //     return false;
  //   }
  // }

  const inputChange = (event, identifier) => {
    let prevState = { ...others };
    if (typeof prevState['updateRate'][identifier] === 'undefined') {
      prevState['updateRate'][identifier] = '';
    }
    prevState['updateRate'][identifier] = event.target.value;
    setOthers(prevState);
  }

  const dayUIHandler = (event, params) => {
    let index = params.index;
    let selectedDays = JSON.parse(JSON.stringify(commonData.selectedDays));
    if (selectedDays.indexOf(index) < 0) {
      selectedDays.push(index);
    } else {
      selectedDays.splice(selectedDays.indexOf(index), 1);
    }
    let prevState = { ...commonData };
    prevState['selectedDays'] = selectedDays;
    setCommonData(prevState);
  }

  const updateRate = () => {
    prepareDataForRateUpdate(commonData, result => {
      let updateRate = JSON.parse(JSON.stringify(others.updateRate));
      let selectedDays = JSON.parse(JSON.stringify(commonData.selectedDays));
      let data = result['rateUpdateData'];
      /*let prevState={...this.state.commonData};
				prevState['rateUpdateData']=result['rateUpdateData'];
			this.setState({
				commonData:prevState
			});*/

      var numericExpression = /^[+-]?([0-9]*[.])?[0-9]+$/;
      if (!numericExpression.test(updateRate.rate)) {
        customAlert(1, 'error', 'Rate is not valid');
        return false;
      }
      /*if(updateRate.extrabed_rate ='undefined'){
				if(!numericExpression.test(updateRate.extrabed_rate)){ alert("ddd");
				this.customAlert(1,"error","Extrabed Rate is not valid");
				return false;
				}
			}
			if(updateRate.kid_rate!='undefined' && !numericExpression.test(updateRate.kid_rate)){
				this.customAlert(1,"error","Child Rate is not valid");
				return false;
			}*/
      if (selectedDays.length === 0) {
        customAlert(1, 'error', 'Please Select a day');
        return false;
      }
      /*** Convert Days index ( start from 1=>sun) ***/
      var dayCode = [];
      for (var i = 0; i < selectedDays.length; i++) {
        dayCode.push(parseInt(selectedDays[i]) + 1);
      }
      updateRateApiEvent(updateRate, data, dayCode);
    });
  }

  const updateRateDateChange = (event, params) => {
    let startDateObj = new Date(params.startDate);
    let endDateObj = new Date(params.endDate);
    let selectedDateYMD = currentDateHandle(event);
    let selectedDateFormate = formatDate(selectedDateYMD, 'yyyy-mm-dd', dateFormate);
    if (event.getTime() > endDateObj.getTime() && params.key === 'start_date') {
      customAlert(1, 'error', 'Start Date should be less then End date');
      return false;
    } else if (startDateObj.getTime() > event.getTime() && params.key === 'end_date') {
      customAlert(1, 'error', 'Start Date should be less then End date');
      return false;
    }
    let prevState = JSON.parse(JSON.stringify(others));
    if (params.key === 'start_date') {
      prevState['ratepopupUiDesign'][params.categoryId][params.occupancyId][params.index][
        'start_date'
      ] = selectedDateYMD;
      prevState['ratepopupUiDesign'][params.categoryId][params.occupancyId][params.index][
        'start_date_display'
      ] = selectedDateFormate;
    } else if (params.key === 'end_date') {
      prevState['ratepopupUiDesign'][params.categoryId][params.occupancyId][params.index]['end_date'] = selectedDateYMD;
      prevState['ratepopupUiDesign'][params.categoryId][params.occupancyId][params.index][
        'end_date_display'
      ] = selectedDateFormate;
    }
    setOthers(prevState, () => {
      let dateDiff = findDateDiff(
        new Date(
          others['ratepopupUiDesign'][params.categoryId][params.occupancyId][params.index]['start_date']
        ),
        new Date(
          others['ratepopupUiDesign'][params.categoryId][params.occupancyId][params.index]['end_date']
        )
      );
      bulkUpdateDataReset(
        others,
        commonData,
        params.ratePlanId,
        params.userId,
        params.categoryId,
        '',
        params.occupancyId,
        response => {
          let prevCommonState = JSON.parse(JSON.stringify(commonData));
          prevCommonState['eventHandlingData'] = response['eventHandlingData'];
          setCommonData(prevCommonState, () => {
            let prevOthersState = JSON.parse(JSON.stringify(others));
            prevOthersState['rateinventorySelectedSection'] = response['rateinventorySelectedSection'];

            setOthers(prevOthersState, () => {
              let dateList = calenderDateUIHandler(
                others['ratepopupUiDesign'][params.categoryId][params.occupancyId][params.index][
                  'start_date_display'
                ],
                dateDiff + 1
              );
              let dateKeyList = Object.keys(dateList);
              for (var i = 0; i < dateKeyList.length; i++) {
                //params.ratePlanId,params.userId,params.categoryId,params.datekey,params.occupancyId
                params.datekey = dateKeyList[i];
                // logicObj.selectCellEventHandler(
                //   params,
                //   others,
                //   commonData,
                //   dateList,
                //   // eslint-disable-next-line no-loop-func
                //   result => {
                //     /*** Update commonData state */
                //     prevCommonState = JSON.parse(JSON.stringify(commonData));
                //     prevCommonState['eventHandlingData'] = result['eventHandlingData'];
                //     setCommonData(prevCommonState);
                //     /**** Update Other state */
                //     let prevOtherState = JSON.parse(JSON.stringify(others));
                //     prevOtherState['horizontalRowChecked'] = result['horizontalRowChecked'];
                //     prevOtherState['showHideButton'] = result['showHideButton'];
                //     setOthers(prevOtherState);
                //   }
                // );
              }
            });
          });
        }
      );
      // this.filterEventHandler(event,params);
    });
  }

  // eslint-disable-next-line max-params
  const bulkUpdateDataReset = (others, commonData, ratePlanId, userId, categoryId, _dateKey, occupancyId, callBack) => {
    let eventHandlingData = JSON.parse(JSON.stringify(commonData.eventHandlingData));
    let rateinventorySelectedSection = JSON.parse(JSON.stringify(others.rateinventorySelectedSection));
    let dateKeys = Object.keys(rateinventorySelectedSection[ratePlanId][userId][categoryId]);
    for (var i = 0; i < dateKeys.length; i++) {
      if (
        typeof rateinventorySelectedSection[ratePlanId][userId][categoryId][dateKeys[i]][occupancyId] !== 'undefined' &&
        rateinventorySelectedSection[ratePlanId][userId][categoryId][dateKeys[i]][occupancyId]['isSelected'] === 1
      ) {
        rateinventorySelectedSection[ratePlanId][userId][categoryId][dateKeys[i]][occupancyId]['isSelected'] = 0;
      }
    }
    let eventHandlingDataReset = [];
    let dateList = Object.keys(eventHandlingData);
    for (var j = 0; j < dateList.length; j++) {
      if (parseInt(eventHandlingData[dateList[j]]['occupancy_id']) !== parseInt(occupancyId)) {
        eventHandlingDataReset.push(eventHandlingData[dateList[j]]);
      }
    }
    let response = {};
    response['rateinventorySelectedSection'] = rateinventorySelectedSection;
    response['eventHandlingData'] = eventHandlingDataReset;
    callBack(response);
  }

  const horizontalInventoryUIHandler = (event, params) => {
    let backupData = JSON.parse(JSON.stringify(backup));
    //let catMapArr=params.categoryId.splite
    horizontalInventoryUIHandler(
      dateList,
      others,
      commonData,
      params.categoryWithMapping,
      params.userId,
      backupData,
      result => {
        let prevOtherState = { ...others };
        prevOtherState['horizontalInventoryRowChecked'] = result['horizontalInventoryRowChecked'];
        prevOtherState['inventorySelectedSection'] = result['inventorySelectedSection'];
        prevOtherState['showHideButton'] = result['showHideButton'];
        prevOtherState['calendarSelectedDate'] = result['calendarSelectedDate'];
        setOthers(prevOtherState, () => {
          let prevCommonState = { ...commonData };
          prevCommonState['InventoryEventHandlingData'] = result['InventoryEventHandlingData'];
          prevCommonState['startStopSaleEventHandlingData'] = result['startStopSaleEventHandlingData'];
          setCommonData(prevCommonState);
        });
      }
    );
  }

  const isAnyCategorySelectedCaseHandler = (categoryId) => {
    if (others.selectedCategory > 0 && others.selectedCategory !== categoryId) {
      return true;
    } else if (others.selectedCategory === 0) {
      let prevState = JSON.parse(JSON.stringify(others));
      prevState['selectedCategory'] = categoryId;
      setOthers(prevState);
      return false;
    } else if (others.selectedCategory === categoryId) {
      let prevState = JSON.parse(JSON.stringify(others));
      prevState['selectedCategory'] = 0;
      setOthers(prevState);
      return false;
    }
  }

  const horizontalRowSelection = (event, params) => {
    if (params.userId > 0) {
      customAlert(1, 'error', 'You can not update OTA rate or inventories');
      return false;
    }
    if (
      commonData.otaData[filterData.userId]['category'][params.categoryId]['rateplans'][
        'type'
      ] === 'package'
    ) {
      customAlert(1, 'error', 'Opps , You can not update package rate');
      return false;
    }
    if (isAnyCategorySelectedCaseHandler(params.categoryId)) {
      customAlert(1, 'error', 'Multiple category rate update not allowed');
      return false;
    }

    horizontalRowSelection(
      params.userId,
      params.rateplanId,
      params.categoryId,
      params.occupancyId,
      others,
      commonData,
      dateList,
      result => {
        let prevOtherState = { ...others };
        prevOtherState['horizontalRowChecked'] = result['horizontalRowChecked'];
        prevOtherState['rateinventorySelectedSection'] = result['rateinventorySelectedSection'];
        prevOtherState['showHideButton'] = result['showHideButton'];
        prevOtherState['selectedCategory'] = result['selectedCategory'];
        setOthers(prevOtherState, () => {
          let prevCommonState = { ...commonData };
          prevCommonState['eventHandlingData'] = result['eventHandlingData'];
          setCommonData(prevCommonState);
        });
      }
    );
  }

  const startStopSaleDateChange = (event, params) => {
    let startDateObj = new Date(params.startDate);
    let endDateObj = new Date(params.endDate);
    let selectedDateYMD = currentDateHandle(event);
    let selectedDateFormate = formatDate(selectedDateYMD, 'yyyy-mm-dd', dateFormate);
    if (event.getTime() > endDateObj.getTime() && params.key === 'start_date') {
      customAlert(1, 'error', 'Start Date should be less then End date');
      return false;
    } else if (startDateObj.getTime() > event.getTime() && params.key === 'end_date') {
      customAlert(1, 'error', 'Start Date should be less then End date');
      return false;
    }
    let popupUiDesignPrevState = JSON.parse(JSON.stringify(others));
    if (params.key === 'start_date') {
      popupUiDesignPrevState['popupUiDesign'][params.categoryId][params.index]['start_date'] = selectedDateFormate;
    } else if (params.key === 'end_date') {
      popupUiDesignPrevState['popupUiDesign'][params.categoryId][params.index]['end_date'] = selectedDateFormate;
    }
    setOthers(popupUiDesignPrevState, () => {
      filterEventHandler(event, params);
    });
  }

  const noBasicData = () => {
    return (
      <div className="cover pad30 border_t_1 border_color_1">
        <div className="ovr tc marg_bottom10">
          <div className="inline">
            <img src="../../../assets/images/no_result.png" alt="No Rate Master Found" />
          </div>
        </div>
        <div className="ovr tc fnt16 bld">No Rate set,please set your rate first</div>
      </div>
    );
  }

  const inventoryInputChangeHandle = (event, params) => {
    let prevState = { ...eventData };
    prevState['numberOfRooms'] = event.target.value;
    setEventData(prevState);
  }

  const inventoryDescriptionChangeHandle = (event) => {
    let prevState = { ...eventData };
    prevState['description'] = event.target.value;
    setEventData(prevState);
  }

  const customAlert = (status, type, message) => {
    let prevState = { ...loader };
    prevState['alert'] = status;
    prevState['type'] = type;
    prevState['message'] = message;
    setLoader(prevState);
    setTimeout(() => {
      prevState = { ...loader };
      prevState['alert'] = 0;
      prevState['type'] = '';
      prevState['message'] = '';
      setLoader(prevState);
    }, 3000);
  }

  return (
    <React.Fragment>
      <Button
        showHideButton={others.showHideButton}
        openPopupSectionUIHandler={openPopupSectionUIHandler}
      />
      <div className="container_fluid pad15">
          <div className="wrapper">
            <div id="stick_bar" className="ovr"></div>
            <div id="inventry_headerfix" className="ovr bg2_4">
              <RateInventoryFilter
                dateChangeHandler={dateChangeHandler}
                filterData={filterData}
                otaList={backup.rateassociatedwithuser}
                others={others}
                filterEventHandler={filterEventHandler}
              />

              <RateInventoryCalender
                filterData={filterData}
                others={others}
                dateList={dateList}
                selectAllInventoryOfDateHandler={selectAllInventoryOfDate}
              />

              <RateInventory
                dateList={dateList}
                others={others}
                commonData={commonData}
                userId={filterData.userId}
                inventoryCellUIHandler={inventoryCellUIHandler}
                expandCollapseCategorySectionHandler={expandCollapseCategorySection}
                selectCellEventHandler={selectCellEventHandler}
                horizontalInventoryUIHandler={horizontalInventoryUIHandler}
                horizontalRowSelection={horizontalRowSelection}
                rateInventory={backup.rateInventory}
                otaCategoryRateplan={backup.ota_category_rateplan}
                rateassociatedwithuser={backup.rateassociatedwithuser}
              />
            </div>
          </div>
      </div>

    </React.Fragment>
  );
};

export default MainInventory;
